import React from 'react';
import { TOTAL_SCREENS } from '../utilities/commonUtils';

// TOTAL_SCREENS is module-level constant so this result is stable — no need to
// recompute it on every PortfolioContainer render
const allScreens = TOTAL_SCREENS.map((screen) =>
  screen.component ? (
    <screen.component
      screenName={screen.screen_name}
      key={screen.screen_name}
      id={screen.screen_name}
    />
  ) : (
    <div key={screen.screen_name}></div>
  )
);

export default function PortfolioContainer() {
  return <div className="portfolio-container">{allScreens}</div>;
}
